module.exports = __webpack_public_path__ + "static/media/board.f6e824be.png";